/* import __COLOCATED_TEMPLATE__ from './badge-collection.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();